import * as actions from './actions';
import * as getters from './getters';

import {
    UPLOAD_DOCUMENTS,
    FETCH_DOCUMENTS,
    DELETE_DOCUMENTS
} from './mutation-types';

const initialState = {
    documents: []
};

const mutations = {
    [UPLOAD_DOCUMENTS](state, payload) {},
    [FETCH_DOCUMENTS](state, documents) {
        state.documents = documents;
    },
    [DELETE_DOCUMENTS](state, documentIds) {
        state.documents = state.documents.filter(
            document => !documentIds.includes(document.id)
        );
    }
};

export default {
    state: {
        ...initialState
    },
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/document/index.js